import React, { useContext, useState} from 'react';
import {IProps} from './types';
import * as S from './styles';
import { Context } from '@routes/private/Editor/Context';
import Slider, { Range } from 'rc-slider';
import ZoomMinusIcon from '@assets/icons/zoomMinusIcon';
import ZoomPlusIcon from '@assets/icons/zoomPlusIcon';
import HandIcon from '@assets/icons/handIcon';
import Tooltip from '@components/Tooltip';
import AddArtboardIcon from '@assets/icons/addArtboardIcon';
import CreateNew from '@routes/private/Studio/components/CreateNew';
import AddArtboard from '../AddArtboard';

const Zoom: React.FC<IProps> = (props) => {
  const { onZoomChange, editorStatus, onDraggingChange } = useContext(Context);

  return (    
    <>      
      <S.Label>Zoom</S.Label>
      <S.Button onClick={()=> onZoomChange(editorStatus.zoom.value-5)}><ZoomMinusIcon/></S.Button>
      <S.SliderContainer>
        <Slider
          min={5}
          max={500}
          step={5}
          startPoint={1}
          value={editorStatus.zoom.value}
          onChange={(e)=> onZoomChange(e)}
          onAfterChange={(e)=> onZoomChange(e)}
          railStyle={{
            height:1,
            background: "#818181"
            
          }}
          handleStyle={{
            height: 10,
            width: 10,                
            marginTop: -4,
            backgroundColor: "#c4c4c4",
            border: 0
          }}
          trackStyle={{
            height:1,
            background: "none"
          }}

          dotStyle={{
            border:0,
            height:5,
            width:5,
            top:-2,
            background: "#c4c4c4"
          }}
        />
      </S.SliderContainer>
      <S.Button onClick={()=> onZoomChange(editorStatus.zoom.value+5)}><ZoomPlusIcon/></S.Button>
    </>
        
  );
}
  
export default Zoom;